import { useCallback, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { AuthContext } from '../contexts/AuthContext';
import { DeadlineAlertItem, MyDeadlineAlerts } from '../types';

export function useDeadlineAlerts(): {
  alerts: DeadlineAlertItem[];
  totalAlerts: number;
  daysLeft: number | null;
  urgencyLabel: string | null;
  loading: boolean;
  refresh: () => Promise<void>;
} {
  const { user } = useContext(AuthContext) || {};
  const [data, setData] = useState<MyDeadlineAlerts | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async (): Promise<void> => {
    if (!user) {
      setData(null);
      return;
    }
    setLoading(true);
    try {
      const res = await api.get<MyDeadlineAlerts>('/notifications/my/deadline-alerts');
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    void refresh();
    if (!user) return;
    const id = window.setInterval(() => void refresh(), 60000);
    return () => window.clearInterval(id);
  }, [user, refresh]);

  const alerts = data?.alerts ?? [];

  return {
    alerts,
    totalAlerts: alerts.length,
    daysLeft: data?.daysLeft ?? null,
    urgencyLabel: data?.urgencyLabel ?? null,
    loading,
    refresh,
  };
}
